<template>
  <div>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration padd">
          <hr class="blue" />
          <h4>Naslov vašega stalnega prebivališča</h4>

          <form action="#" class="custom-form" _lpchecked="1">
            <div class="form-group">
              <input type="text" class="form-control" name="street" id="street" />
              <label for="street" class="animated-label">Ulica in hišna številka</label>
              <span class="line"></span>
            </div>

            <div class="form-group">
              <input type="number" class="form-control" name="post" id="post" />
              <label for="post" class="animated-label">Poštna številka</label>
              <span class="line"></span>
            </div>

            <div class="form-group">
              <input type="text" class="form-control" name="city" id="city" />
              <label for="city" class="animated-label">Kraj</label>
              <span class="line"></span>
            </div>

            <hr class="blue topMargin" />
            <h4>Vaša mobilna številka</h4>
            <div class="flex phoneNumber">
              <div class="form-group zipNumber">
                <label class="animated-label">+386</label>
                <span class="line"></span>
              </div>

              <div class="form-group">
                <input type="text" class="form-control" name="Number" id="Number" />
                <label for="Number" class="animated-label">Telefonska številka</label>
                <span class="line"></span>
              </div>
            </div>
            <div class="next flex">
              <a
                class="txt"
                href="https://studiolev.si/warp-panel/on_board_basic.html"
              >Prejšnji korak</a>
              <a class="join smallFont hoverEffect" href="on_board_education.html">
                <label>Naslednji korak</label>
                <span class="effect"></span>
                <img src="@/assets/images/nextArrowAnimation.svg" />
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      notCompleted: true,
    };
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>
<style>
</style>